import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import MyLists from "../ui/my_lists/MyLists";
import MyListAddEdit from "../ui/my_lists/MyListAddEdit";
import MyListDetails from "../ui/my_lists/MyListDetails";
import MyListsList from "../ui/my_lists/MyListsList";

const MyListsRoutes = (
  <Route
    path={AppSections.MY_LISTS}
    element={
      <ProtectedRoute>
        <MyLists />
      </ProtectedRoute>
    }
  >
    <Route path="/my_lists/" element={<MyListsList />} />
    <Route path="create" element={<MyListAddEdit />} />
    <Route path=":id/view" element={<MyListDetails />} />
    <Route path=":id/edit" element={<MyListAddEdit />} />
  </Route>
);

export default MyListsRoutes;
